/* TetBoard  - by Matthew Vecchio / ReadyWolf 
 * a tetris like board grid
 *
 *
 *  
 * 
 *  
 */
import Phaser from 'phaser'
import { gSettings } from "../settings/gamesettings";
import * as mJS from  '../common/mvUtils.js'
import  Rat from '../classes/Rat.js';


export default class TetGrid  {
    name = "noname"
    ratID = 0;
    xLength = 0;
    yLength = 0;
    gridArray = [[]];
    debug = true;
    rats = new Array();
    totalRatCount = 0;
    noRoamingRats = 0;
    noNestedRats = 0;
    ratsClearArray = [];
    rowsToClear = [];
    ratsRowsAlreadySpawned = [];
    rowsReadyToClear = false;
    rowsClearNextTime = 0;
    rowsClearTimeSet = false;

    initArray() {
        this.gridArray = new Array(this.xLength); // create an empty array of length x
        for (var i = 0; i < this.yLength; i++) { // how many rows
            this.gridArray[i] = new Array(this.xLength); // make each element an array
        }
 
    }
        // col check for grid array -1 = bottom of array, 0 legal move, 1 obstructed move
   
        /* old  version
        check(x , y) {
        var result = 0; 

        if (y == gSettings.GAME_GRID_SIZE_Y) {
           return result = -1;
        }

        if (this.gridArray[y][x] == 0) {
            console.log( "result false");
            result = 0;
        }

        if (this.gridArray[y][x] == 1  ) {
            console.log( "result true");

            result = 1;
        }
        return result;
    }
*/
    // check that  position is within the X and Y of the grid -1 = y ,
    //     -1
    //   -3[ ]-4
    //     -2


    checkInBounds(x,y) {
        
        if (y >= gSettings.GAME_GRID_SIZE_Y) return -2;
        if (x >= gSettings.GAME_GRID_SIZE_X) return -4;
        if (x < 0 ) return -3;
        if (y < 0 ) return -1;
        return 0;
        
        

    }



    // check that all the blocks don't 
    checkBlk(valArray, x , y, vx = 0, vy = 0, r) {
        let result = 1; 
        let yOff = 0;
        let xOff = 0;
        result = 0;

      

        for (let i = 0; i < valArray[r].length; i++) {
             
            if (valArray[r][i] == 1) {
              result = this.check(x + xOff, y + yOff,vx,vy);

              if (result != 0) {
                return result; // exit early if something hits
              }
            }
            xOff++;
                if (xOff > 3 || valArray[r][i] == 2) { yOff++; xOff = 0;}
            
        }

        return result;
    }


    checkRatOnRat(id, x,y,vx,vy) {
        let result = 0;

        for (let i = 0; i < this.rats.length; i++) {
            if (this.rats[i].id == id) continue;
            if (this.rats[i].posX == x + vx && this.rats[i].posY == y + vy ) {
                result = 1;
            }
            


        }

        return result;


    }

    // single check for X Y coord -- 0 = OK, -1 above, -2 below, -3 left, -4 right, 1 Y hit, 2 X hit 4 XY hit
    check(x , y, vx = 0, vy = 0) {
        let result = 0;


        // check that the is within the array 0 = OK, -1 above, -2 below, -3 left, -4 right
        result = this.checkInBounds(x + vx,y + vy);
        // check block is within bounds...
        if (result != 0) return result;

        if (this.gridArray[y + vy][x + vx] == 0) {
         //   console.log( "result - no col" + result);
            return result = 0;
        }

        if (this.gridArray[y + vy][x] >= 1|| this.gridArray[y ][x + vx] == -8 || this.gridArray[y ][x + vx] == -9 || this.gridArray[y ][x + vx] == -10 ) {
        //   console.log( "result Y true");

            return result = 1; // 1 y axis hit
        }

        if (this.gridArray[y ][x + vx] >= 1 || this.gridArray[y ][x + vx] == -8 || this.gridArray[y ][x + vx] == -9 || this.gridArray[y ][x + vx] == -10  ) {
         //  console.log( "result Y true");

            return result = 2; // 2 x axis hit
        }

        if (this.gridArray[y + vy][x + vx] >= 1 || this.gridArray[y ][x + vx] == -8 || this.gridArray[y ][x + vx] == -9 || this.gridArray[y ][x + vx] == -10 ) {
        //console.log( "result Y true");

            return result = 4; // 1 y axis hit
        }

        return result;
   
    }


    insertBlk( valArray, x, y, r, value ) {
        let yOff = 0;
        let xOff = 0;
        let mosXY = [0,0,0];
        let uniqueXVals = [];
        let posData = [];

        for (let i = 0; i < valArray[r].length; i++) {
            if (y + yOff > this.GAME_GRID_SIZE_X || x + xOff > this.GAME_GRID_SIZE_Y) break; 
         
          if (valArray[r][i] == 1) {
         
            this.gridArray[y + yOff][x + xOff] = value;
            posData.push( (x + xOff) );
            posData.push( (y + yOff) );
   

            if (uniqueXVals.includes(x + xOff) == false) uniqueXVals.push(x + xOff);
            
            if (x + xOff > mosXY[0])  mosXY[0] = x + xOff;
            if (y + yOff > mosXY[1]) mosXY[1] = y + yOff;
          }
          xOff++;
          if (xOff > 3 || valArray[r][i] == 2) {yOff++; xOff = 0;}
     
        }

        let xPixOffSet = 0;
        if (uniqueXVals.length == 1) xPixOffSet = 0;
        if (uniqueXVals.length == 2) xPixOffSet = (gSettings.TILE_SIZE * gSettings.TILE_SCALE) / 2;
        if (uniqueXVals.length == 3) xPixOffSet =  (gSettings.TILE_SIZE * gSettings.TILE_SCALE);
        if (uniqueXVals.length == 4) xPixOffSet =  (gSettings.TILE_SIZE * gSettings.TILE_SCALE) + ((gSettings.TILE_SIZE * gSettings.TILE_SCALE) / 2);
        if (uniqueXVals.length == 5) xPixOffSet =  (gSettings.TILE_SIZE * gSettings.TILE_SCALE) + ((gSettings.TILE_SIZE * gSettings.TILE_SCALE));
        xPixOffSet /= 2;
        mosXY[2] = xPixOffSet;
        for (let i = 0; i < posData.length;i++) {
        mosXY.push(posData[i]);
        }
//        mosXY += posData;
       

        return mosXY;

    }
 

    insert( x, y, value ) {
       try {
          this.gridArray[y][x] = value;
       } catch {
           console.log("error outside of array: [y][x]" + y + " " + x );
           this.gridArray[y][x] = value;
        }
    }

    lineMoveDown(rowValue) {

    let x = 0;
    let y = 0;
    var ratFound = 0;
     for (let y = rowValue; y > 0; y--) {
        for (let x = 0; x < gSettings.GAME_GRID_SIZE_X ; x++) {

        // if any of the values are a player don't move
            if (this.gridArray[y][x] == -1 || 
                this.gridArray[y][x] == -2 || 
                this.gridArray[y][x] == -3 ||
                this.gridArray[y][x] == -4 
                ) continue;
         ratFound = 0;    
     // check if any bricks contain nested rats and if so unnest them...
        if (this.gridArray[y ][x] == 8 || this.gridArray[y][x] == 9 || this.gridArray[y ][x] == 10) {
 
       
            // turn rat into active again...
            for (let i = 0; i < this.rats.length; i++) {
                if (x == this.rats[i].posX && y == this.rats[i].posY && this.rats[i].currentlyNested == true) {
                    this.rats[i].nestedRat = false;
                    this.rats[i].currentlyNested = false;
                    this.rats[i].posY--;
                    this.gridArray[y][x] = 0;

                    ratFound++;
                }
            }
          
        }
        if (ratFound > 0 ) { this.gridArray[y + 1 ][x] = 0; }
        else this.gridArray[y][x] = this.gridArray[y - 1][x]; 
   

        

        }
    } 
    // clear the top row...
	for (let i = 0; i < gSettings.GAME_GRID_SIZE_X;i++) {
        this.insert(i,0,0);
    }
   
    }

    randomise(startRowNum = 0, endRowNum = gSettings.GAME_GRID_SIZE_Y - 1, amount = 10, value = 1) {
        for (let i = 0; i < amount;i++) {
            this.insert(mJS.getRandomInt( 0, gSettings.GAME_GRID_SIZE_X- 1),mJS.getRandomInt( startRowNum, endRowNum),value);
        }
    }

    lineSetRowArrayPaint(rowArray) {

        for (var i = 0; i < rowArray.length; i++) {
            for (let xPos = 0; xPos < gSettings.GAME_GRID_SIZE_X;xPos++) {
/*
            if (this.gridArray[rowArray[i]][xPos] == 8 || this.gridArray[rowArray[i]][xPos] == 9 || this.gridArray[rowArray[i]][xPos] == 10) 
                { 

                }
                else {
*/
                    this.insert(xPos,rowArray[i],this.gridArray[rowArray[i]][xPos] * 100);
  //              }
  

            }
        }


    }

    lineSetRowArray(rowArray, value) {

        for (var i = 0; i < rowArray.length; i++) {
            for (let xPos = 0; xPos < gSettings.GAME_GRID_SIZE_X;xPos++) {

                if (this.gridArray[rowArray[i]][xPos] == 8 || this.gridArray[rowArray[i]][xPos] == 9 || this.gridArray[rowArray[i]][xPos] == 10) 
                { 

                }
                else {

                    this.insert(xPos,rowArray[i],value);
                }
  

            }
        }


    }

    isGridValueAtGridPos(rowY,xPos,value) {
        if (this.grideArray[rowY][xPos] == value) {
            return true;
        } else {
            return false;
        }
    }

    getGridValueAtGridPos(rowY,xPos,value) {


        return this.gridArray[rowY][xPos];
    }

    getRatIndexByID(id) {

        
        var returnVal = -1;
        for (var i = 0; i < this.rats.length; i++) {
            if (this.rats[i].id == id) {
                returnVal = i;
                break;
            }

        }
        return returnVal;
    }

    getRatIndexAtPos(rowY,xPos) {

        let ratPos = this.getGridValueAtGridPos(rowY,xPos);
        var returnVal = -1;
        for (var i = 0; i < this.rats.length; i++) {
            if (this.rats[i].posX == xPos && this.rats[i].posY == rowY) {
                returnVal = i;
                break;
            }

        }
        return returnVal;
    }

    // clear multiple lines fix 
    lineClearRowArray(rowArray, clearArray = false) {


      
       for (var i = 0; i < rowArray.length; i++) {

        // free the rat row...
        if ( gSettings.RAT_MODE == true) {
            if (this.ratsRowsAlreadySpawned.includes(rowArray[i])) {
                this.ratsRowsAlreadySpawned.splice(this.ratsRowsAlreadySpawned.indexOf(rowArray[i]),1); 
            }
            
        }


            for (let xPos = 0; xPos < gSettings.GAME_GRID_SIZE_X;xPos++) {

              if (this.gridArray[rowArray[i]][xPos] == 8 
                || this.gridArray[rowArray[i]][xPos] == 9 
                || this.gridArray[rowArray[i]][xPos] == 10) 
                { 
                this.ratsClearArray.push(this.gridArray[rowArray[i]][xPos]);
                // remove the rat from the array
                let r = this.getRatIndexAtPos(rowArray[i], xPos);
                this.rats.splice(r,1);

              } 

              this.insert(xPos,rowArray[i],0);
            }
       }

       for (let i = rowArray.length; i > -1; i--) {
          this.lineMoveDown(rowArray[i]);
       }

       if (clearArray == true) {
         this.rowsToClear = []; 
       }
    }

    // move everything down 1
    writeRow(rowNumber, value = 0) {

        for (let xPos = 0; xPos < gSettings.GAME_GRID_SIZE_X;xPos++) {
            this.insert(xPos,rowNumber,1);
        }
     

    }

    findAndReplaceFromArray(oldvalue, newValue) {

        let x = 0;
        let y = 0;

        for (x = 0; x < this.yLength; x++ ) { // how long is each row...
            for (y = 0; y < this.xLength; y++) { // how long is each column
                if ( this.gridArray[x][y] == oldvalue) {
                    this.gridArray[x][y] = newValue;
                }
            } 

        }
    }

    removeRatsFromArray() {

        let x = 0;
        let y = 0;

        for (x = 0; x < this.yLength; x++ ) { // how long is each row...
            for (y = 0; y < this.xLength; y++) { // how long is each column
                if ( this.gridArray[x][y] == -8 || this.gridArray[x][y] == -9  || this.gridArray[x][y] == -10 ) {
                this.gridArray[x][y] = 0;
                }
            } 

        }

        this.updateRatArray();

    }

    updateRatArray() {

        var indexesOfRatsToRemove = [];

        for (let i = 0; i < this.rats.length; i++) {
        
            if (this.rats[i].killRat == true) {
                // kill rat animation
               // console.log("rat killed");
                this.rats[i].killSprite = true;
                indexesOfRatsToRemove.push(i);
            
            }
        }

        for (let i = 0; i < indexesOfRatsToRemove.length;  i++) {
            this.rats.splice(indexesOfRatsToRemove[i],1);
           // console.log("rat array cleaned");

        }
/*
        for (let i =  indexesOfRatsToRemove.length; i > 0; i--) {
            this.rats.splice(indexesOfRatsToRemove[i],1);
            console.log("rat array cleaned");

        }
        */
    }

    insertRatsIntoArray() {


        this.totalRatCount = 0;
        this.noRoamingRats = 0;
        this.noNestedRats = 0;
 
        for (let i = 0; i < this.rats.length; i++) {




           this.totalRatCount++;

           if (this.rats[i].nestedRat == false && this.rats[i].killRat == false && this.check(this.rats[i].posX, this.rats[i].posY,0,0) == 0) {
            
            this.noRoamingRats++
            this.insert(this.rats[i].posX, this.rats[i].posY,-this.rats[i].ratType);


           } else if (this.rats[i].nestedRat == true && this.rats[i].currentlyNested == false && this.rats[i].killRat == false && this.check(this.rats[i].posX, this.rats[i].posY,0,0) == 0)  {
            this.insert(this.rats[i].posX, this.rats[i].posY,this.rats[i].ratType);
            this.rats[i].currentlyNested = true;
 
           }

           if (this.rats[i].currentlyNested == true) {
            this.noNestedRats++;
           }
        }

        // check through grid and check for nested rats
        /*
        for (let y = 0; y < this.yLength; y++ ) { // how long is each row...
            for (let x = 0; x < this.xLength; x++) { // how long is each column
                
                if (Math.abs(this.gridArray[y][x]) == 8 || Math.abs(this.gridArray[y][x]) == 9 || Math.abs(this.gridArray[y][x]) == 10 ) {
                    console.log("rat found");
                    let leftChk = 0;
                    let rightChk = 0;
                    if (x == 0) leftChk = 1;
                    else {
                        if ( Math.abs(this.gridArray[y][x - 1])  == 8 
                        ||   Math.abs(this.gridArray[y][x - 1])  == 9 
                        ||   Math.abs(this.gridArray[y][x - 1]) == 10
                        ||  this.gridArray[y][x - 1] >= 1)
                            leftChk = 1;
                            console.log("left is true");
                        
                    }
                    if (x == this.xLength - 1) rightChk = 1;
                    else {
                        if ( Math.abs(this.gridArray[y][x + 1])  == 8 
                        ||   Math.abs(this.gridArray[y][x + 1])  == 9 
                        ||   Math.abs(this.gridArray[y][x + 1]) == 10
                        || this.gridArray[y][x + 1] >= 1)
                        rightChk = 1;       
                        console.log("right is true");                 
                    }
                    
                    
    
                 
                    if (rightChk == 1 && leftChk == 1 ) {
                        let r = 0;
                        console.log("FORCE RAT NEST!");
                        r = this.getRatIndexAtPos(y,x);
                        if (r >= 0)
                         this.rats[r].nestedRat = true;
                    }
                 

                }
           
            }
        } 
            */

    }

    getRatsClearedArray() {
        var returnVal = this.ratsClearArray;


        this.ratsClearArray = [];
        return returnVal;
    }
    // move rats here
    updateRats(time, delta) {



        
  
        // rat on nested rat collision detection & logic
        for (var a = 0; a < this.rats.length; a++) {
            for (var b = 0; b < this.rats.length; b++) {
            if (this.rats[a].id == this.rats[b].id ) continue;
            if (this.rats[a].posX == this.rats[b].posX && this.rats[a].posY == this.rats[b].posY  && this.rats[b].currentlyNested == true  ) {

                // find a position if two rats in the same spot and one of them is nested
                let x = this.rats[a].posX;
                let y = this.rats[a].posY;


          
                if (this.check(x,y,-1,0) == 0)  this.rats[a].posX--;  
                else if (this.check(x,y,1,0) == 0)   this.rats[a].posX++;
                else if (this.check(x,y,0,-1) == 0)       this.rats[a].posY--;
                else if (this.check(x,y,0,1) == 0)       this.rats[a].posY++;
                else if (this.check(x,y,-1,-1) == 0) {
                    this.rats[a].posX--;
                    this.rats[a].posY--;
              
                }
                else if (this.check(x,y,1,-1) == 0) {
                    this.rats[a].posX++;
                    this.rats[a].posY--;
           
                }
                else if (this.check(x,y,-1,1) == 0) {
                    this.rats[a].posX--;
                    this.rats[a].posY++;
                   
                }
                else if (this.check(x,y,1,1) == 0) {
                    this.rats[a].posX++;
                    this.rats[a].posY++;
                    
                } else 
                    this.rats[a].killRat = true;
                
                }



            }
            
        }

        for (let i = 0; i < this.rats.length; i++) {

            let vx = 0;
            let vy = 0; 
            let x = this.rats[i].posX;
            let y = this.rats[i].posY;
            let stopChk = false;
            let result = 0;
            // check if rat is on same space
            /*
            let result = this.check(x,y,0,0);
            if (result != 0 && this.rats[i].currentlyNested == false) {
                // check if rat can move up...
                if (this.check(x,y,0,-1) == 0) {   
                    this.rats[i].posY = -1;
                } 
                else if (this.check(x,y,-1,0) == 0) {   
                    this.rats[i].posX = -1;
                }
                else if (this.check(x,y,1,0) == 0) {   
                    this.rats[i].posX = 1;
                }
                else if (this.check(x,y,-1,-1) == 0) {   
                    this.rats[i].posX = -1;
                    this.rats[i].posY = -1;
                }
                else if (this.check(x,y,1,-1) == 0) {   
                    this.rats[i].posX = 1;
                    this.rats[i].posY = -1;
                }  else if (this.check(x,y,0,-2) == 0) {   
                    this.rats[i].posX = -1;
                } 
                else {
                    this.rats[i].killRat = true;
                }
                return;
                
            } 
            */




            if (this.rats[i].ratLastMove < time && this.rats[i].nestedRat == false ) {        
             
               // TODO move this to the rat object
               let randTime = mJS.getRandomInt(0,100);
                this.rats[i].ratLastMove = (time + gSettings.RAT_SPEED) + randTime;
                if (this.rats[i].isFalling) 
                    this.rats[i].ratLastMove = (time + (gSettings.RAT_SPEED / 2));
                
                if (this.rats[i].nestedRat == false) {
                    if (
                        this.check(x,y,0,1) != 0 && 
                        (this.check(x,y,-1,0) != 0 || ( this.checkRatOnRat(this.rats[i].id,x,y,-1,0) != 0 && this.check(x,y,-2,0) != 0  ) ) && 
                        (this.check(x,y,1,0) != 0  || ( this.checkRatOnRat(this.rats[i].id,x,y,1,0)  != 0 && this.check(x,y,2,0) != 0   ) ) &&
                            this.check(x,y,0,0) == 0 && this.checkRatOnRat(this.rats[i].id,x,y,0,0) == 0
                        ) { 
                            this.rats[i].nestedRat = true;
                            this.rats[i].isFalling = false;
                            continue;
                        }
                    }


                // apply gravity
                vy = 1;
              

                if (this.rats[i].direction == 1) {
                    vx++;
                    
                }
                if (this.rats[i].direction == -1) {
                    vx--;
                }

               



                


                // first check that no bricks are in the same space
                
                result = this.check(x,y,0,0);
                if (result != 0 && this.rats[i].currentlyNested == false) {

                 
         
                    
                    // check if rat can move up...
                    if (this.check(x,y,0,-1) == 0) {   
                        vy = -1;
                    }  else {
   // game plays better with a simple rat check
                    this.rats[i].killRat = true;
                    return;
                    }

                /*     these are removed to suggest that rats have to escape upwards 
                    else if (this.check(x,y,-1,0) == 0) {   
                       vx = -1;
                  }
                  else if (this.check(x,y,1,0) == 0) {   
                        vx = 1;
                   }
                    else if (this.check(x,y,-1,-1) == 0) {   
                        vx = -1;
                        vy = -1;
                    }
                    else if (this.check(x,y,1,-1) == 0) {   
                        vx = 1;
                        vy = -1;
                       
                    }  
                    else {
                        this.rats[i].killRat = true;
                        return;
                    }*/
                   
                }
                  
                    

                
                
                if (stopChk == false) {// the actual space is OK so lets check movement...


                    // Y CHECK
                    result = this.check(x,y,0,vy);
                    
                    switch(result) {
                        case 0:
                            if (this.check(x,y,0,vy + 1) == 0) { // rat only falls if gap is over 2 spaces
                            this.rats[i].isFalling = true;
                            this.rats[i].direction = 0;
                            stopChk = true;
                            vx = 0;
                            }
                            else if (this.check(x,y,0,vy ) == 0) {  // keeps going if it just steps down
                               // stopChk = true;
                                vx = 0;
                            }
                           // stopChk = true;
                        break;          
                        case 1:
                        case -2:
                            vy = 0;
                            if (this.rats[i].isFalling == true) {
                                if (mJS.getRandomInt(0,1) == 0) {
                                    this.rats[i].direction = -1;
                                } else {
                                    this.rats[i].direction = 1;
                                }
                            }
                          
                            this.rats[i].isFalling = false;
                            
                        break;
                    
                    }
                }
                       
                if (stopChk == false) {
                        // then check X movement
                    result = this.check(x,y,vx,0);
                        // single check for X Y coord -- 0 = OK, -1 above, -2 below, -3 left, -4 right, 1 Y hit, 2 X hit 4 XY hit

                    switch(result) {
                        case 0:
                            if (this.rats[i].isFalling == true) vx = 0;
                        break;          
                        case 2:
                            // check if rat can climb
                            if (this.check(x,y,0,-1) == 0 && this.check(x,y,this.rats[i].direction,-1) == 0) {
                                vy = -1;
                                vx = this.rats[i].direction;
                            } else {
                                vx = 0;
                            this.rats[i].direction = -this.rats[i].direction;
                            }
                    
                        break;
                    }
                }
              


                // edge check

                // check if rat is stuck on the left
                if (this.rats[i].posX + vx < 0) {
                    this.rats[i].direction = 1;
                    vx = 0;
                }

                // check if rat is stuck on the right
                if (this.rats[i].posX + vx > gSettings.GAME_GRID_SIZE_X - 1) {
                    this.rats[i].direction = -1;
                    vx = 0;
                }

                // apply velocity.



                
                this.rats[i].posX += vx;
                this.rats[i].posY += vy;


                                // check if rat is nested - includes rat check /*


            }
        }

    }


    spawnRat(ratPosRow, xPos = -1) {
   
        let ratSpawned = false;
        var xValue = xPos;
        var randomPos = false;
        if (xPos == -1) {
            randomPos = true;
        }
        // 
        while (ratSpawned == false ) {

            if (randomPos) xValue = mJS.getRandomInt(0,gSettings.GAME_GRID_SIZE_X - 1);
            if (this.check(xValue,ratPosRow,0,0) == 0) {

                this.rats.push(new Rat(xValue, ratPosRow, this.ratID++));
  
                ratSpawned = true;
                
            }
            ratPosRow--;
          
        }


    }

    // checks if any lines in the grid are filled and if returns number of lines called
    lineCheck() {


        
        let completedLineValue = gSettings.GAME_GRID_SIZE_X;
        let potentialClearedLine = 0;
        let clearedLines = 0;
       
        var ratsToSpawn = 0;
        let x = 0;
        let y = 0;

        // work backwards from the bottom incase of multiple lines
        for (y =  gSettings.GAME_GRID_SIZE_Y - 1; y >= 0; y-- ) { // columes
            potentialClearedLine = 0;
            for (x = 0; x < this.xLength; x++) { // row
               if (this.gridArray[y][x] >= 1) potentialClearedLine++;
    
         
               if (potentialClearedLine == completedLineValue ) {
                clearedLines += 1;
                this.rowsToClear.push(y);
               } else if (potentialClearedLine == completedLineValue - 1 && gSettings.RAT_MODE == true ) {
                if (this.ratsRowsAlreadySpawned.includes(y) == false) {
                    ratsToSpawn++;
                    this.ratsRowsAlreadySpawned.push(y);
                }
               }

            } 
           
        }
        
        if (ratsToSpawn > 0) {
    
            for (let i = 0; i < ratsToSpawn; i++ ) {
                this.spawnRat(0); // spawn rat to the top
            }
        

        }

        if (clearedLines > 0) {
      
       
           //delayedCall(delay, callback, args, callbackScope)
           if (gSettings.LINE_CLEAR_DELAY == false) {
             this.lineSetRowArray(this.rowsToClear,11);
         
            this.lineClearRowArray(this.rowsToClear, true);
           } else {
            this.rowsReadyToClear = true;
           }
     
  
        }        
        return clearedLines;

    }

    constructor(name = "TetGrid", xSize = 10, ySize = 24 ) {
     
        this.name = name;
        this.xLength = xSize;
        this.yLength = ySize;
        this.initArray();

        

        this.zero();
    }



    // zeros ('clears' the out the array
    zero() {
        let x = 0;
        let y = 0;
        for (x = 0; x < this.yLength; x++ ) { // how long is each row...
            for (y = 0; y < this.xLength; y++) { // how long is each column
                this.gridArray[x][y] = 0;
            } 

        }

        this.ratDataReset();

    }

    ratDataReset() {
        this.rats.length = 0;
        this.ratsCleared = 0;
        this.rowsToClear = [];
        this.rowsReadyToClear = false;
        this.rowsClearNextTime = 0;
        this.rowsClearTimeSet = false;
        this.ratID = 0;
        this.ratsRowsAlreadySpawned = [];
    }

    // Reports the array
    details() {

       console.log( this.name );
       console.log( this.xLength);
       console.log( this.yLength);


    }

    draw(blocks) {


    }

    report() {
        let str = "x"  + this.xLength + " y" + this.yLength + "\n";
 
        for (var i = 0; i <  this.gridArray.length; i++) {
            
            str += i
            if (i < 10) str += " "
            str += "  "
            for (var j = 0; j <  this.gridArray[i].length; j++) {
                 str += this.gridArray[i][j]; // prints each element in the array
            }
             str += "\n"
         }
         return str; 
     }
}